var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHairdresser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_27364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71 15.5799C8.98 15.1599 9.96 13.4299 10.24 12.2499C11.61 6.64994 9.43 0.779941 9.42 0.689941L9.09 2.31994C9.09 2.31994 9.23 8.18994 8.84 11.1999C8.79 11.5799 9.14 12.1199 9.06 12.4099L8.34 15.3299C7.13 15.5599 6.43 16.7699 6.8 17.9099C7.14 18.9599 8.27 19.5399 9.32 19.2099C10.97 18.6799 11.2 16.4499 9.71 15.5799ZM9.4 10.4299C9.49 10.2499 9.71 10.1799 9.89 10.2699C10.07 10.3599 10.14 10.5799 10.05 10.7599C9.96 10.9399 9.74 11.0099 9.56 10.9199C9.38 10.8299 9.31 10.6099 9.4 10.4299ZM9.08 18.4799C8.43 18.6899 7.74 18.3299 7.53 17.6799C7.32 17.0299 7.68 16.3399 8.33 16.1299C8.98 15.9199 9.67 16.2799 9.88 16.9299C10.09 17.5799 9.73 18.2699 9.08 18.4799Z",
    fill: "#5868B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 14.8599C15.99 13.7299 14.71 13.1399 13.59 13.6599L11.29 11.6999C11.06 11.5199 11.02 10.8699 10.76 10.5899C10.7 10.5299 10.64 10.4599 10.58 10.3899L10.24 12.2499C11.17 13.0299 12.95 13.8999 12.61 14.6499C11.91 16.2199 13.41 17.8999 15.05 17.3699C16.1 17.0299 16.68 15.9099 16.34 14.8599H16.35ZM14.82 16.6399C14.17 16.8499 13.48 16.4899 13.27 15.8399C13.06 15.1899 13.42 14.4999 14.07 14.2899C14.72 14.0799 15.41 14.4399 15.62 15.0899C15.83 15.7399 15.47 16.4299 14.82 16.6399Z",
    fill: "#5868B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86005 11.04C7.14005 9.02003 4.56005 5.73003 3.55005 3.28003C6.11005 4.86003 9.03005 8.70003 9.03005 8.70003",
    fill: "#5868B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_27364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairdresser);
export default __webpack_public_path__ + "static/media/hairdresser.cc664546.svg";
export { ForwardRef as ReactComponent };